import VueMatomo from "vue-matomo";
import { getMatomoConfig } from "../matomoConfig";

export const COOKIE_NAME = "COOKIE_CONSENT";
export const COOKIE_ANALYTICS = "analytics";
export const COOKIE_NONE = "none";

export function useCookieConsent(instance, clientStore) {
  function readConsentCookie() {
    const cookiesRaw = document.cookie;
    const cookies = cookiesRaw.split(";");
    let analyticCookies = false;
    let cookieExists = false;
    let cookieExistsOnLoad = false;

    cookies.map((element) => {
      const cookie = element.split("=");
      const key = cookie[0];
      const value = cookie[1];

      if (key.trim() === COOKIE_NAME) {
        switch (value) {
          case COOKIE_ANALYTICS:
            analyticCookies = true;
            break;
          case COOKIE_NONE:
            analyticCookies = false;
            break;
        }
        cookieExists = true;
        cookieExistsOnLoad = true;
      }
    });
    return { analyticCookies, cookieExists, cookieExistsOnLoad };
  }

  function acceptAll(saveSettings, setAnalyticCookies) {
    setAnalyticCookies(true);
    setTimeout(saveSettings, 300);
  }

  function saveSettings(
    deleteAllCookies,
    createCookieConsentCookie,
    getSettingsPayload,
    emit,
    onSaveCookieSettings,
    setCookieConsentModalOpen,
    setCookieExists
  ) {
    deleteAllCookies();
    createCookieConsentCookie();
    setCookieConsentModalOpen(false);
    setCookieExists(true);
    const settings = getSettingsPayload();
    emit("onSaveSettings", settings);
    onSaveCookieSettings(settings);
  }

  function deleteAllCookies() {
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      const name = cookies[i].trim();
      const pathBits = location.pathname.split("/");
      let pathCurrent = " path=";
      document.cookie = name + "=; expires=Thu, 01-Jan-1970 00:00:01 GMT;";
      for (let i = 0; i < pathBits.length; i++) {
        pathCurrent += (pathCurrent.substr(-1) != "/" ? "/" : "") + pathBits[i];
        document.cookie =
          name +
          "=; expires=Thu, 01-Jan-1970 00:00:01 GMT;" +
          pathCurrent +
          ";";
      }
    }
  }

  function createCookieConsentCookie(analyticCookies) {
    let cookie = COOKIE_NAME + "=";
    if (analyticCookies) {
      cookie += COOKIE_ANALYTICS;
    } else {
      cookie += COOKIE_NONE;
    }
    cookie += ";path=/";
    const CookieDate = new Date();
    CookieDate.setFullYear(CookieDate.getFullYear() + 1);
    cookie += ";expires=" + CookieDate.toUTCString() + "";
    document.cookie = cookie;
  }

  function getSettingsPayload(
    cookieExists,
    analyticCookies,
    cookieExistsOnLoad
  ) {
    const emitPayload: Record<string, any> = {};
    if (!cookieExists) {
      emitPayload[COOKIE_ANALYTICS] = false;
    } else {
      emitPayload[COOKIE_ANALYTICS] = analyticCookies;
    }
    emitPayload.cookieExistsOnLoad = cookieExistsOnLoad;
    return { ...emitPayload };
  }

  function onCookieSettingsLoaded(settings, installPlugins) {
    installPlugins(settings);
  }

  function onSaveCookieSettings(
    settings,
    installPlugins,
    setCookieConsentOpen
  ) {
    setCookieConsentOpen(false);
    installPlugins(settings);
    location.reload();
  }

  function installPlugins() {
    // Check if Matomo is already initialized by looking for the Matomo script
    const matomoScriptExists = !!document.querySelector(
      'script[src*="matomo"]'
    );
    if (!matomoScriptExists) {
      instance.appContext.app.use(
        VueMatomo,
        getMatomoConfig(instance.proxy.$router, clientStore.getMatomoId)
      );
    }
    // @ts-expect-error Matomo _paq is injected globally by Matomo script
    if (window._paq) {
      // @ts-expect-error Matomo _paq is injected globally by Matomo script
      window._paq.push(["setConsentGiven"]);
    }
  }

  function uninstallPlugins() {
    // Remove Matomo script from DOM
    const matomoScript = document.querySelector('script[src*="matomo"]');
    if (matomoScript && matomoScript.parentNode) {
      matomoScript.parentNode.removeChild(matomoScript);
    }
    // Attempt to disable Matomo tracking if available
    // @ts-expect-error Matomo _paq is injected globally by Matomo script
    if (window._paq) {
      // @ts-expect-error Matomo _paq is injected globally by Matomo script
      window._paq.push(["disableCookies"]);
      // @ts-expect-error Matomo _paq is injected globally by Matomo script
      window._paq.push(["forgetUserOptOut"]);
      // @ts-expect-error Matomo _paq is injected globally by Matomo script
      window._paq.push(["setConsentGiven", false]);
      window._paq.push(["forgetConsentGiven"]);
    }
  }

  function isSbk() {
    return clientStore.getForeignSystemId !== null;
  }

  return {
    readConsentCookie,
    acceptAll,
    saveSettings,
    deleteAllCookies,
    createCookieConsentCookie,
    getSettingsPayload,
    onCookieSettingsLoaded,
    onSaveCookieSettings,
    installPlugins,
    uninstallPlugins,
    isSbk,
  };
}
